<div>
  @if (!this.gridConfig.showGridFilters) {
    <button
      type="button"
      mat-button
      color="primary"
      class="mb-2 pull-right"
      (click)="toggleFilters()"
    >
      <mat-icon>search</mat-icon>
      Find Another Account
    </button>
  }

  <app-rb-grid
    [gridConfig]="gridConfig"
    [getSetup]="getGridSetup"
    [getData]="getGridData"
  />
</div>
